// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    background: rgba(0, 22, 29, 0.60);
}
.modal-content {
    border-radius: 15px;
    position: relative;
    max-width: 90%;
    color: white;
    background-color: #00161D;
    border: 1px solid white;
}
/* Scrollbar styles */
.modal-content div::-webkit-scrollbar {
    width: 10px;
    background: rgba(255, 255, 255, 0.23);
    border-radius: 5px;
}
/* Handle */
.modal-content div::-webkit-scrollbar-thumb {
    background: var(--blue);
    border-radius: 5px;
    border: 1px solid white;
}

.modal-close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 18px;
    cursor: pointer;
}
.modal-header{
    font-size: 28px;
    font-weight: lighter;

}
.modal-body {
    white-space: pre-line;
    max-height: 90vh;
}
`, "",{"version":3,"sources":["webpack://./src/css/modal.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iCAAiC;AACrC;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;AAC3B;AACA,qBAAqB;AACrB;IACI,WAAW;IACX,qCAAqC;IACrC,kBAAkB;AACtB;AACA,WAAW;AACX;IACI,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,oBAAoB;;AAExB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB","sourcesContent":["\n.modal{\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n    background: rgba(0, 22, 29, 0.60);\n}\n.modal-content {\n    border-radius: 15px;\n    position: relative;\n    max-width: 90%;\n    color: white;\n    background-color: #00161D;\n    border: 1px solid white;\n}\n/* Scrollbar styles */\n.modal-content div::-webkit-scrollbar {\n    width: 10px;\n    background: rgba(255, 255, 255, 0.23);\n    border-radius: 5px;\n}\n/* Handle */\n.modal-content div::-webkit-scrollbar-thumb {\n    background: var(--blue);\n    border-radius: 5px;\n    border: 1px solid white;\n}\n\n.modal-close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: transparent;\n    border: none;\n    font-size: 18px;\n    cursor: pointer;\n}\n.modal-header{\n    font-size: 28px;\n    font-weight: lighter;\n\n}\n.modal-body {\n    white-space: pre-line;\n    max-height: 90vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
